import { setEstabPrice, toMoney, TripType, useGlobalContext, useSearch } from '@honeycomb/data';
import { getNonInfantsCount } from '../../../../utils';
import { useHotelBasketContext } from '../../HotelBasketProvider';
export const useHotelBasketTotals = () => {
    var _a;
    const { currentContext } = useGlobalContext();
    const { hotelBasket } = useHotelBasketContext();
    const { selectedRooms, selectedFlight, waitingForRooms, waitingForFlights, estabId } = hotelBasket;
    const [{ tripType, rooms }] = useSearch([]);
    const isHoliday = tripType === TripType.Holiday;
    const nonInfantCount = rooms.reduce((prev, cur) => {
        return prev + getNonInfantsCount(cur);
    }, 0);
    if (waitingForRooms || (isHoliday && waitingForFlights)) {
        return null;
    }
    if (selectedRooms.length === 0) {
        return null;
    }
    if (isHoliday && !selectedFlight) {
        return null;
    }
    const { cultureCode, currencyCode } = currentContext;
    const flightDeltaPrice = (_a = selectedFlight === null || selectedFlight === void 0 ? void 0 : selectedFlight.deltaPrice) !== null && _a !== void 0 ? _a : 0;
    const roomsTotal = selectedRooms.reduce((acc, a) => {
        var _a, _b;
        const roomPrice = ((_b = (_a = a === null || a === void 0 ? void 0 : a.pricingSummary) === null || _a === void 0 ? void 0 : _a.teaserPrice) === null || _b === void 0 ? void 0 : _b.value) || 0;
        return acc + roomPrice;
    }, 0);
    const wasPriceTotal = selectedRooms.reduce((acc, room) => {
        var _a, _b;
        const wasPrice = (_b = (_a = room === null || room === void 0 ? void 0 : room.pricingSummary) === null || _a === void 0 ? void 0 : _a.wasPrice) !== null && _b !== void 0 ? _b : 0;
        return acc + wasPrice;
    }, 0);
    const total = roomsTotal + flightDeltaPrice;
    const perPerson = total / nonInfantCount;
    const wasPricePerPerson = wasPriceTotal / nonInfantCount;
    // Sets the Estab price in local storage
    // Used for logging price diffs
    setEstabPrice({
        estabId,
        price: total,
    });
    return {
        total: toMoney(total, cultureCode, currencyCode, true),
        perPerson: toMoney(perPerson, cultureCode, currencyCode, true),
        wasPrice: toMoney(wasPriceTotal, cultureCode, currencyCode, true),
        wasPricePerPerson: toMoney(wasPricePerPerson, cultureCode, currencyCode, true),
    };
};
